<template>
  <div name="hres6oe-cust-latlng" id="hres6oe-cust-latlng" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header header-popup">
          <button type="button" class="close" data-dismiss="modal" ref="btnCloseModal">&times;</button>
          <h4 class="modal-title">{{ labels['HRES6OEC3']['10'] }}</h4>
        </div>
        <hrms-search-box-table 
                v-model="searchIndexLocation"
                :data="data"
                :nowLang="app.nowLang"
                :columns="placeNewLatLngColumns"
                :receivedStore="receivedCheckInPlaceNoLocation"
                searchBoxAlias="hres6oe"
                :searchDisp="false"
                :selectRowBool="true"
                :selectBtnDisp="true"
                :selectEvent="selectEvent"
                :confirmSelectBtnDisp="true"
                :unLoadBool="true"
                ref="custNearSelect" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hres6oe-cust-latlng',
  props: [ 'labels', 'placeNewLatLngColumns', 'data', 'setCustNewLatLngSelected', 'receivedCheckInPlaceNoLocation', 'flgClearFilterLocation', 'holdFilterLocation' ],
  data () {
    return {
      app: this.$root.$children[0],
      searchIndexLocation: {
        namcust: '',
        codcust: '',
        codprovr: '',
        zipcode: ''
      }
    }
  },
  watch: {
    flgClearFilterLocation () {
      if (this.flgClearFilterLocation) {
        this.searchIndexLocation.namcust = ''
        this.searchIndexLocation.codcust = ''
        this.searchIndexLocation.codprovr = ''
        this.searchIndexLocation.zipcode = ''
        this.$nextTick(() => {
          this.errors.clear()
        })
        this.holdFilterLocation()
      }
    }
  },
  methods: {
    selectEvent (checkedDataRows) {
      let dataRowsFiltered = checkedDataRows.filter(function (dataRow) {
        return dataRow.flgSelect === 'Y'
      })
      this.setCustNewLatLngSelected(dataRowsFiltered)
      this.$refs.btnCloseModal.click()
    }
  }
}
</script>



// WEBPACK FOOTER //
// custNewLatLng.vue?64d6c632